import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';

import { ObservableScope } from '../models/observable-scope.enum';
import { AngularEvents } from '../shared-context/angular-events';
import { ScopableObservable, ScopableSubject } from '../utilities/scopable-subject.utility';
import { WindowService } from './window.service';

export interface AppEvent {
    readonly name: AngularEvents;
    readonly args: Array<any>;
}

@Injectable({
    providedIn: 'root'
})
export class EventService {
    private readonly _events: ScopableSubject<AppEvent> = new ScopableSubject();

    constructor(private readonly windowService: WindowService) {
        this.mutateGlobalWindowState();
    }

    public broadcastEvent(event: AppEvent) {
        this._events.next(event);
    }

    public get events(): ScopableObservable<AppEvent> {
        return this._events.asScopableObservable();
    }

    public whenEventFired(eventName: AngularEvents, scope: ObservableScope): Promise<AppEvent> {
        return this.events.withScope(scope).pipe(
            filter(event => event.name === eventName),
            take(1)
        ).toPromise();
    }

    // Try to keep all global mutable state changes here so side effects are obvious
    private mutateGlobalWindowState() {
        this.windowService.nativeWindow.ng2EventService = this;
    }
}
